import React from "react";
import SearchBar from "./SearchBar";
import Radio from "./Radio";
import IconFilter from "./IconFilter";

const FilterRenderer = ({
  filterOption,
  selectedFilters,
  onFilterChange,
  searchInputRef,
}) => {
  if (!filterOption?.isActive) {
    return null;
  }

  switch (filterOption.type) {
    case "searchbar":
      return (
        <SearchBar
          placeholder={filterOption.name || filterOption.hintname || "Search here"}
          filterName={filterOption.name || "search"}
          inputRef={searchInputRef}
          onSearch={onFilterChange}
        />
      );

    case "radio":
      return (
        <Radio
          filterName={filterOption.name}
          options={filterOption.options}
          placeholder={filterOption.name || "Select Option"}
          value={selectedFilters[filterOption.name] || ""}
          onChange={onFilterChange}
        />
      );

    case "iconFilter":
      return (
        <IconFilter
          filterOption={filterOption}
          onFilterChange={onFilterChange}
          selectedFilters={selectedFilters}
        />
      );

    default:
      return null;
  }
};

export default FilterRenderer;
